import UserImage from "assets/images/user-nobg.jpg";

export default function getUserAvatar(avatar) {
  return avatar
    ? avatar.startsWith("https://")
      ? avatar
      : `${process.env.REACT_APP_MEDIA_URL}${avatar}`
    : UserImage;
}
